import { HiOutlineLocationMarker } from "react-icons/hi";
import SmartPhone from "../../Shared/SvgIcons/SmartPhone";

const MyBusinessListingDetails = () => {
  return (
    <div className="flex w-4/5 justify-between gap-10">
      <p className="font-pop text-base font-medium text-primary">67 Views</p>

      <div className="flex items-center gap-3">
        <HiOutlineLocationMarker className=" h-5 w-5 text-redBorder" />
        <span className="font-pop text-base font-light text-cardSecondaryColor">
          Pretoria
        </span>
      </div>

      <div className="flex items-center gap-3">
        <SmartPhone className="h-5 w-5 text-primary" />
        <span className="font-pop text-base font-light text-cardSecondaryColor">
          5 Phone clicks
        </span>
      </div>
    </div>
  );
};

export default MyBusinessListingDetails;
